var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIconConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#A0EE09",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.901 21.2462C16.691 22.4193 15.9375 24.0713 15.9375 25.9016C15.9375 29.4607 18.7868 32.3458 22.3017 32.3458C24.6143 32.3458 26.6388 31.0968 27.7532 29.2285C27.2557 29.3225 26.7426 29.3716 26.2181 29.3716C21.7215 29.3716 18.0579 25.7607 17.901 21.2462Z",
    fill: "#A0EE09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1374 17.4667L16.8289 17.7164C16.2956 18.1482 14.546 19.5733 15.0355 20.5647C14.9992 20.5256 14.9599 20.4879 14.9305 20.4421C14.0564 19.0776 15.5457 17.2192 16.3975 16.5296L15.7809 15.7487L18.3098 15.7495L17.7539 18.2475L17.1374 17.4667Z",
    fill: "#A0EE09"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.873 30.5305L31.1769 30.2751C31.7023 29.8334 33.4258 28.3761 32.9184 27.3939C32.9554 27.4323 32.9954 27.4693 33.0256 27.5145C33.9242 28.8626 32.4689 30.7483 31.6297 31.4536L32.2603 32.2229L29.7319 32.2691L30.2424 29.7612L30.873 30.5305Z",
    fill: "#A0EE09"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5818 20.9444C32.5818 24.5035 29.7325 27.3886 26.2177 27.3886C22.7028 27.3886 19.8535 24.5035 19.8535 20.9444C19.8535 17.3853 22.7028 14.5001 26.2177 14.5001C29.7325 14.5001 32.5818 17.3853 32.5818 20.9444ZM29.155 20.2233H26.5849V16.9786L23.2804 21.6654H25.8505V24.91L29.155 20.2233Z",
    fill: "#A0EE09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconConvert);
export default __webpack_public_path__ + "static/media/menu-icon-convert.070314a1e637bd289e85e119ef0dfc6d.svg";
export { ForwardRef as ReactComponent };